export default __webpack_public_path__ + "static/media/motor3.120a59cd.jpg";